import { IMucThuNhapHocSinhVienSelectRequest } from "../../model/request/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienSelectRequest";
import { apiClient } from "../apiClient";
export const MUC_THU_NHAP_HOC_SINH_VIEN = "muc-thu-nhap-hoc-sinh-vien";
/** Lọc phạm vi đồng bộ lại mức thu nhập học. 0 = không lọc. */
export interface IDongBoMucThuNhapHocRequest {
  nam_nhap_hoc: number;
  dot_nhap_hoc: number;
  id_thu_chi: number;
  id_svs?: string[];
  /** Id dòng công nợ được tích chọn. Rỗng = mọi dòng lệch. */
  ids?: number[];
}

/** 1 dòng công nợ đang lệch so với thiết lập mức thu. */
export interface IDongBoMucThuNhapHocItem {
  id: number;
  id_sv: string;
  ma_sv?: string;
  ho_ten?: string;
  id_thu_chi: number;
  ten_thu_chi?: string;
  so_tien_cu: number;
  so_tien_moi: number;
  so_tien_da_nop: number;
  so_tien_con_lai: number;
  /** Dương = phải nộp thêm, âm = giảm (có thể sinh tiền thừa). */
  chenh_lech: number;
}

export const mucThuNhapHocSinhVienApi = {
  SelectBySinhVien: (request: IMucThuNhapHocSinhVienSelectRequest) =>
    apiClient.post(`${MUC_THU_NHAP_HOC_SINH_VIEN}/select-by-sinhvien`, request),
  /** Phiếu chi gộp nhiều nguồn: trả mảng khoản theo ĐÚNG thứ tự `id_bien_lais`. */
  SelectKhoanChiSinhVienMulti: (request: IMucThuNhapHocSinhVienSelectRequest) =>
    apiClient.post(
      `${MUC_THU_NHAP_HOC_SINH_VIEN}/select-khoan-chi-sinhvien-multi`,
      request
    ),
  /** Chỉ xem trước, KHÔNG ghi gì. */
  XemTruocDongBoMucThu: (request: IDongBoMucThuNhapHocRequest) =>
    apiClient.post(
      `${MUC_THU_NHAP_HOC_SINH_VIEN}/xem-truoc-dong-bo-muc-thu`,
      request
    ),
  /** Ghi số tiền theo thiết lập vào công nợ SV rồi tính lại công nợ. */
  DongBoMucThu: (request: IDongBoMucThuNhapHocRequest) =>
    apiClient.post(`${MUC_THU_NHAP_HOC_SINH_VIEN}/dong-bo-muc-thu`, request),
  /**
   * % miễn giảm nhập học của 1 SV — gọi RIÊNG, NGAY SAU khi đã nạp sinh viên.
   *
   * Sinh viên lấy từ danh sách có cache, còn miễn giảm thì trường xét SAU khi SV nộp hồ sơ nên
   * phải hỏi riêng để luôn ra số mới nhất. ĐỪNG nhét số này vào bản ghi sinh viên.
   */
  SelectMienGiamNhapHoc: (id_sv: string) =>
    apiClient.get(`${MUC_THU_NHAP_HOC_SINH_VIEN}/mien-giam-nhap-hoc/${id_sv}`),
};
